import { Layers } from "appworks/graphics/layers/layers";
import { ControlFactory } from "appworks/ui/factories/control-factory";
import { TotalStakeTextControlFactory } from "appworks/ui/factories/standard/total-stake-text-control-factory";
import { AgsTotalStakeTextControl } from "../ags-total-stake-text-control";

export class AgsTotalStakeTextControlFactory extends TotalStakeTextControlFactory implements ControlFactory {
    public build(layer: Layers) {
        return [new AgsTotalStakeTextControl(layer.getFlexiText("total_stake"))];
    }
}
